module.exports = {
  rgpReachCalc: function(cffcnt, grps) {
    grps = parseFloat(grps);
    var z = (
      cffcnt.a +
      cffcnt.b1 * Math.log(grps) +
      cffcnt.b2 * Math.pow(Math.log(grps), 2) +
      cffcnt.b3 * Math.pow(Math.log(grps), 3)
    );
    var z2 = 1 + Math.exp(-z);
    var result = (cffcnt.lmt / z2) * 100;
    return result;
  },
  classifyMedia: function(channelLevelResult, inteMedia) {
    for(var i=0; i <channelLevelResult.length; i++){
      switch(channelLevelResult[i].media) {
          case 'TV':
              if(channelLevelResult[i].channel == '전체'){
                  inteMedia.tvMedia.overall = channelLevelResult[i];
              }else{
                var code = channelLevelResult[i].channel.charAt(0);
                inteMedia.tvMedia.inte_ModelCode += code;
                inteMedia.tvMedia.mediaList[channelLevelResult[i].channel] = channelLevelResult[i];
              }

              break;
          case 'PC':
              if(channelLevelResult[i].channel == '전체'){
                  inteMedia.pcMedia.overall = channelLevelResult[i];
              }else if(channelLevelResult[i].channel == 'Portal' || channelLevelResult[i].channel == '동영상매체'
              || channelLevelResult[i].channel == 'Network'){
                var existCode = inteMedia.pcMedia.inte_ModelCode.indexOf('E');
                if(existCode>-1){
                  // 기타매체가 코드값에 포함됬으므로 별도의 작업은 하지 않는다.
                }else{
                  inteMedia.pcMedia.inte_ModelCode += 'E';
                }
                inteMedia.pcMedia.etcMediaList.push(channelLevelResult[i]);
              }else {
                var code = channelLevelResult[i].channel.charAt(0);
                inteMedia.pcMedia.inte_ModelCode += code;
                inteMedia.pcMedia.mediaList[channelLevelResult[i].channel] = channelLevelResult[i];
              }
              break;
          case 'Mobile':
              if(channelLevelResult[i].channel == '전체'){
                  inteMedia.mobileMedia.overall = channelLevelResult[i];
              }else if(channelLevelResult[i].channel == 'Portal' || channelLevelResult[i].channel == '동영상매체'
              || channelLevelResult[i].channel == 'Network'){
                var code = channelLevelResult[i].channel.charAt(0);
                var existCode = code.indexOf('E');
                if(existCode>-1){
                  // 기타매체가 코드값에 포함됬으므로 별도의 작업은 하지 않는다.
                }else{
                  inteMedia.mobileMedia.inte_ModelCode += 'E';
                }
                inteMedia.mobileMedia.etcMediaList.push(channelLevelResult[i]);
              }
              else{
                var code = channelLevelResult[i].channel.charAt(0);
                inteMedia.mobileMedia.inte_ModelCode += code;
                inteMedia.mobileMedia.mediaList[channelLevelResult[i].channel] = channelLevelResult[i];
              }
              break;
          case 'Digital':
              if(channelLevelResult[i].channel == '전체'){
                  inteMedia.digitalMedia.overall = channelLevelResult[i];
              }
              else if(channelLevelResult[i].channel == 'Portal' || channelLevelResult[i].channel == '동영상매체'
              || channelLevelResult[i].channel == 'Network'){
                var code = channelLevelResult[i].channel.charAt(0);
                var existCode = code.indexOf('E');
                if(existCode>-1){
                  // 기타매체가 코드값에 포함됬으므로 별도의 작업은 하지 않는다.
                }else{
                  inteMedia.digitalMedia.inte_ModelCode += 'E';
                }
                inteMedia.digitalMedia.etcMediaList.push(channelLevelResult[i]);                 }
              else {
                var code = channelLevelResult[i].channel.charAt(0);
                inteMedia.digitalMedia.inte_ModelCode += code;
                inteMedia.digitalMedia.mediaList[channelLevelResult[i].channel] = channelLevelResult[i];
              }
              break;
          }
        }
    this.sortModelCode(inteMedia.tvMedia);
    this.sortModelCode(inteMedia.pcMedia);
    this.sortModelCode(inteMedia.mobileMedia);
    this.sortModelCode(inteMedia.digitalMedia);

    return inteMedia;

  },
  sortModelCode: function(mediaInfo){
    var str = mediaInfo.inte_ModelCode;
    str = str.split("");
    str = str.sort();
    str = str.join("");
    mediaInfo.inte_ModelCode = str;
  },
  calcTVMedia : function(tvMedia, inte_cffcnt){
    if(tvMedia.inte_ModelCode.length > 1){
      // 먼저 기타매체 처리로직
      switch(tvMedia.inte_ModelCode) {
        case '지케': // 지상파 케이블 , A2로직
            tvMedia.screenCount = 2;
            tvMedia.reachA = tvMedia.mediaList['지상파'].reach1;
            tvMedia.reachALabel = '지상파';
            tvMedia.reachB = tvMedia.mediaList['케이블'].reach1;
            tvMedia.reachBLabel = '케이블';
            this.BN2_Logic(tvMedia, tvMedia.mediaList['지상파'], tvMedia.mediaList['케이블'], 'BN2_3', inte_cffcnt);
            break;
        case '종지': // 지상파 종편 , A2로직
            tvMedia.screenCount = 2;
            tvMedia.reachA = tvMedia.mediaList['지상파'].reach1;
            tvMedia.reachALabel = '지상파';
            tvMedia.reachB = tvMedia.mediaList['종편'].reach1;
            tvMedia.reachBLabel = '종편';
            this.BN2_Logic(tvMedia, tvMedia.mediaList['지상파'], tvMedia.mediaList['종편'], 'BN2_4', inte_cffcnt);
            break;
        case '종케': // 종편 케이블 , A2로직
            tvMedia.screenCount = 2;
            tvMedia.reachA = tvMedia.mediaList['종편'].reach1;
            tvMedia.reachALabel = '종편';
            tvMedia.reachB = tvMedia.mediaList['케이블'].reach1;
            tvMedia.reachBLabel = '케이블';
            this.BN2_Logic(tvMedia, tvMedia.mediaList['케이블'], tvMedia.mediaList['종편'], 'BN2_5', inte_cffcnt);
            break;
        case '종지케': // 지상파 종편 케이블 A3로직
            tvMedia.screenCount = 3;
            tvMedia.reachA = tvMedia.mediaList['지상파'].reach1;
            tvMedia.reachALabel = '지상파';
            tvMedia.reachB = tvMedia.mediaList['종편'].reach1;
            tvMedia.reachBLabel = '종편';
            tvMedia.reachC = tvMedia.mediaList['케이블'].reach1;
            tvMedia.reachCLabel = '케이블';

            this.BN2_Logic(tvMedia, tvMedia.mediaList['지상파'], tvMedia.mediaList['종편'], 'BN2_4', inte_cffcnt);
            tvMedia.reachAB = tvMedia.resultMedia.reach1;

            this.BN2_Logic(tvMedia, tvMedia.mediaList['지상파'], tvMedia.mediaList['케이블'], 'BN2_3', inte_cffcnt);
            tvMedia.reachAC = tvMedia.resultMedia.reach1;

            this.BN2_Logic(tvMedia, tvMedia.mediaList['케이블'], tvMedia.mediaList['종편'], 'BN2_5', inte_cffcnt);
            tvMedia.reachBC = tvMedia.resultMedia.reach1;

            this.BN3_Logic(tvMedia, tvMedia.mediaList['지상파'], tvMedia.mediaList['종편'], tvMedia.mediaList['케이블'],'BN3_1', 'channel', inte_cffcnt);
            tvMedia.reachABC = tvMedia.resultMedia.reach1;
            break;
      }
    }else if(tvMedia.inte_ModelCode.length == 1){
      switch (tvMedia.inte_ModelCode) {
        case '지':
          tvMedia.resultMedia = tvMedia.mediaList['지상파'];
          break;
        case '종':
          tvMedia.resultMedia = tvMedia.mediaList['종편'];
          break;
        case '케':
          tvMedia.resultMedia = tvMedia.mediaList['케이블'];
          break;
        default:
      }
    }else if(tvMedia.overall !== null && tvMedia.inte_ModelCode == ''){
      // TV매체 처리로직 종료
      tvMedia.resultMedia = tvMedia.overall;
    }else if(tvMedia.overall !== null && tvMedia.inte_ModelCode != ''){
      // this.mediaProcessingFlag++;
    }else{
    }
  },
  calcDigitalMedia: function(digitalMedia, inte_cffcnt){
    if(digitalMedia.inte_ModelCode.length > 1){
      switch(digitalMedia.inte_ModelCode) {
        case 'SY': // SMR Youtube , A2 Logic
            digitalMedia.screenCount = 2;
            digitalMedia.reachA = digitalMedia.mediaList['Youtube'].reach1;
            digitalMedia.reachALabel = 'Youtube';
            digitalMedia.reachB = digitalMedia.mediaList['SMR'].reach1;
            digitalMedia.reachBLabel = 'SMR';
            this.BN2_Logic(digitalMedia, digitalMedia.mediaList['Youtube'], digitalMedia.mediaList['SMR'], 'BN2_1', inte_cffcnt);
            break;
        case 'FY': // Facebook Youbute , B Logic
            digitalMedia.screenCount = 2;
            digitalMedia.reachA = digitalMedia.mediaList['Facebook'].reach1;
            digitalMedia.reachALabel = 'Facebook';
            digitalMedia.reachB = digitalMedia.mediaList['Youtube'].reach1;
            digitalMedia.reachBLabel = 'Youtube';
            this.BN2_Logic(digitalMedia, digitalMedia.mediaList['Youtube'], digitalMedia.mediaList['Facebook'], 'BN2_2', inte_cffcnt);
            break;
        case 'FS': // Facebook SMR , B Logic
            digitalMedia.screenCount = 2;
            digitalMedia.reachA = digitalMedia.mediaList['Facebook'].reach1;
            digitalMedia.reachALabel = 'Facebook';
            digitalMedia.reachB = digitalMedia.mediaList['SMR'].reach1;
            digitalMedia.reachBLabel = 'SMR';
            this.BN2_Logic(digitalMedia, digitalMedia.mediaList['SMR'], digitalMedia.mediaList['Facebook'], 'BN2_2', inte_cffcnt);
            break;
        case 'FSY': // Facebook SMR Youtube , A2 Logic - B Logic
            this.BN2_Logic(digitalMedia, digitalMedia.mediaList['Youtube'], digitalMedia.mediaList['SMR'], 'BN2_1', inte_cffcnt);
            var A2LogicChannel = $.extend(true, {}, digitalMedia.resultMedia);
            // [start 벤다이어그램용]
            digitalMedia.screenCount = 3;
            digitalMedia.reachA = digitalMedia.mediaList['Youtube'].reach1;
            digitalMedia.reachALabel = 'Youtube';
            digitalMedia.reachB = digitalMedia.mediaList['SMR'].reach1;
            digitalMedia.reachBLabel = 'SMR';
            digitalMedia.reachC = digitalMedia.mediaList['Facebook'].reach1;
            digitalMedia.reachCLabel = 'Facebook';

            digitalMedia.reachAB = digitalMedia.resultMedia.reach1;

            this.BN2_Logic(digitalMedia, digitalMedia.mediaList['Youtube'], digitalMedia.mediaList['Facebook'], 'BN2_2', inte_cffcnt);
            digitalMedia.reachAC = digitalMedia.resultMedia.reach1;

            this.BN2_Logic(digitalMedia, digitalMedia.mediaList['SMR'], digitalMedia.mediaList['Facebook'], 'BN2_2', inte_cffcnt);
            digitalMedia.reachBC = digitalMedia.resultMedia.reach1;
            // [end   벤다이어그램용]
            this.BN2_Logic(digitalMedia, A2LogicChannel, digitalMedia.mediaList['Facebook'], 'BN2_2', inte_cffcnt);
            digitalMedia.reachABC = digitalMedia.resultMedia.reach1; // 밴다이어그램용
            break;
        default:
      }
    }else if(digitalMedia.inte_ModelCode.length == 1){
      switch (digitalMedia.inte_ModelCode) {
        case 'S':
          digitalMedia.resultMedia = digitalMedia.mediaList['SMR'];
          break;
        case 'Y':
          digitalMedia.resultMedia = digitalMedia.mediaList['Youtube'];
          break;
        case 'F':
          digitalMedia.resultMedia = digitalMedia.mediaList['Facebook'];
          break;
        default:
      }

    }else if(digitalMedia.overall !== null){
    }
    // this.mediaProcessingFlag++;
  },
  makeTotalLevelCode(inteMedia){
    // totalLevelCode
    var totalLevelCode='';
    if(inteMedia.tvMedia.resultMedia !== null){
      totalLevelCode += 'T'
    }
    if(inteMedia.pcMedia.resultMedia !== null){
      totalLevelCode += 'P'
    }
    if(inteMedia.mobileMedia.resultMedia !== null){
      totalLevelCode += 'M'
    }
    if(inteMedia.digitalMedia.resultMedia !== null){
      totalLevelCode += 'D'
    }
    return totalLevelCode;
  },
  calcTotalLevel(totalLevelCode, inteMedia, inte_cffcnt){
    switch (totalLevelCode) {
      case 'T':
        break;
      case 'P':
        break;
      case 'M':
        break;
      case 'D':
        break;
      case 'TP':
        inteMedia.totalMedia.reachA = inteMedia.tvMedia.resultMedia.reach1;
        inteMedia.totalMedia.reachALabel = 'TV';
        inteMedia.totalMedia.reachB = inteMedia.pcMedia.resultMedia.reach1;
        inteMedia.totalMedia.reachBLabel = 'PC';

        this.BN2_Logic(inteMedia.totalMedia, inteMedia.tvMedia.resultMedia, inteMedia.pcMedia.resultMedia, 'BN2_8', inte_cffcnt);
        break;
      case 'TM':
        inteMedia.totalMedia.reachA = inteMedia.tvMedia.resultMedia.reach1;
        inteMedia.totalMedia.reachALabel = 'TV';
        inteMedia.totalMedia.reachB = inteMedia.mobileMedia.resultMedia.reach1;
        inteMedia.totalMedia.reachBLabel = 'Mobile';

        this.BN2_Logic(inteMedia.totalMedia, inteMedia.tvMedia.resultMedia, inteMedia.mobileMedia.resultMedia, 'BN2_9', inte_cffcnt);
        break;
      case 'TD':
        inteMedia.totalMedia.reachA = inteMedia.tvMedia.resultMedia.reach1;
        inteMedia.totalMedia.reachALabel = 'TV';
        inteMedia.totalMedia.reachB = inteMedia.digitalMedia.resultMedia.reach1;
        inteMedia.totalMedia.reachBLabel = 'Digital';

        this.BN2_Logic(inteMedia.totalMedia, inteMedia.tvMedia.resultMedia, inteMedia.digitalMedia.resultMedia, 'BN2_6', inte_cffcnt);
        break;
      case 'PM':
        inteMedia.totalMedia.reachA = inteMedia.pcMedia.resultMedia.reach1;
        inteMedia.totalMedia.reachALabel = 'PC';
        inteMedia.totalMedia.reachB = inteMedia.mobileMedia.resultMedia.reach1;
        inteMedia.totalMedia.reachBLabel = 'Mobile';

        this.BN2_Logic(inteMedia.totalMedia, inteMedia.pcMedia.resultMedia, inteMedia.mobileMedia.resultMedia, 'BN2_7', inte_cffcnt);
        break;
      case 'TPM':

        inteMedia.totalMedia.reachA = inteMedia.tvMedia.resultMedia.reach1;
        inteMedia.totalMedia.reachALabel = 'TV';
        inteMedia.totalMedia.reachB = inteMedia.pcMedia.resultMedia.reach1;
        inteMedia.totalMedia.reachBLabel = 'PC';
        inteMedia.totalMedia.reachC = inteMedia.mobileMedia.resultMedia.reach1;
        inteMedia.totalMedia.reachCLabel = 'Mobile';
        // $.extend(true, {}, digitalMedia.resultMedia)
        var tvMediaResult = $.extend(true, {}, inteMedia.tvMedia.resultMedia);
        var pcMediaResult = $.extend(true, {}, inteMedia.pcMedia.resultMedia);
        var mobileMediaResult = $.extend(true, {}, inteMedia.mobileMedia.resultMedia);

        this.BN2_Logic(inteMedia.totalMedia, tvMediaResult, pcMediaResult, 'BN2_8', inte_cffcnt);
        inteMedia.totalMedia.reachAB = inteMedia.totalMedia.resultMedia.reach1;

        this.BN2_Logic(inteMedia.totalMedia, tvMediaResult, mobileMediaResult, 'BN2_9', inte_cffcnt);
        inteMedia.totalMedia.reachAC = inteMedia.totalMedia.resultMedia.reach1;

        this.BN2_Logic(inteMedia.totalMedia, pcMediaResult, mobileMediaResult, 'BN2_7', inte_cffcnt);
        inteMedia.totalMedia.reachBC = inteMedia.totalMedia.resultMedia.reach1;

        this.BN3_Logic(inteMedia.totalMedia, tvMediaResult, pcMediaResult, mobileMediaResult,'BN3_2', 'media', inte_cffcnt);
        inteMedia.totalMedia.reachABC = inteMedia.totalMedia.resultMedia.reach1;
        break;
      default:

      // 토탈레벨결과 show 플래그 true
    }
  },
  BN2_Logic(mediaTemplate, mediaA, mediaB, int_cffcnt_CD, inte_cffcnt){
    var mediaABReach =  parseFloat(mediaA.reach1) +  parseFloat(mediaB.reach1);
    var maxReach = Math.max(mediaA.reach1, mediaB.reach1);
    var minReach = Math.min(mediaA.reach1, mediaB.reach1);
    var inteGRP  = parseFloat(mediaA.grps) + parseFloat(mediaB.grps);
    var maxReachMediaInfo = $.extend(true, {}, mediaA);

    var bn2Result = this.BN2_calc(mediaA, mediaB, int_cffcnt_CD, inte_cffcnt);
    if(bn2Result > minReach){
      bn2Result = minReach;
    }
    var inteReach = mediaABReach - bn2Result;

    if(inteReach <= maxReach){
      inteReach = maxReach;
    }else if(inteReach >=  mediaABReach){
      inteReach = mediaABReach;
    }
    maxReachMediaInfo.reach1 = inteReach;
    maxReachMediaInfo.grps = inteGRP;
    mediaTemplate.resultMedia = maxReachMediaInfo;
  },
  BN2_calc(mediaA, mediaB, int_cffcnt_CD, inte_cffcnt){
    // var mediaABReach =  parseFloat(mediaA.reach1) +  parseFloat(mediaB.reach1);
    // console.log(inte_cffcnt);
    var cffcnt = inte_cffcnt[int_cffcnt_CD];
    var z1 = Math.log((mediaA.reach1/100)/(cffcnt.ca-mediaB.reach1/100))*cffcnt.ba
    var z2 = Math.log((mediaB.reach1/100)/(cffcnt.cb-mediaB.reach1/100))*cffcnt.bb
    var z3 = cffcnt.cint / (1+Math.exp((cffcnt.a + (z1 + z2))*-1));
    // var inteReach = mediaABReach - z3;
    return z3*100; // 중복노출값
  },
  BN3_Logic(mediaTemplate, mediaA, mediaB, mediaC, int_cffcnt_CD, gubun, inte_cffcnt){
    var mediaABCReach =  parseFloat(mediaA.reach1) + parseFloat(mediaB.reach1) + parseFloat(mediaC.reach1);
    var inteGRP  = parseFloat(mediaA.grps) + parseFloat(mediaB.grps) + parseFloat(mediaC.grps);
    var maxReachMediaInfo = $.extend(true, {}, mediaA);
    var maxReach = Math.max(mediaA.reach1, mediaB.reach1, mediaC.reach1);
    var minReach = Math.min(mediaA.reach1, mediaB.reach1, mediaC.reach1);

    var tmp1 = 0.0;
    var tmp2 = 0.0;
    var tmp3 = 0.0;
    if(gubun == 'media') { // TV PC MO
      tmp1 = this.BN2_calc(mediaA, mediaB, 'BN2_8', inte_cffcnt);
      tmp2 = this.BN2_calc(mediaA, mediaC, 'BN2_9', inte_cffcnt);
      tmp3 = this.BN2_calc(mediaC, mediaB, 'BN2_7', inte_cffcnt);
    } else { // 지 종 케
      tmp1 = this.BN2_calc(mediaA, mediaB, 'BN2_4', inte_cffcnt);
      tmp2 = this.BN2_calc(mediaA, mediaC, 'BN2_3', inte_cffcnt);
      tmp3 = this.BN2_calc(mediaC, mediaB, 'BN2_5', inte_cffcnt);
    }
    var tmp4 = this.BN3_calc(mediaA, mediaB, mediaC, int_cffcnt_CD, inte_cffcnt);
    if(tmp4 > minReach){
      tmp4 = minReach;
    }
    // var tmp4 = mediaABCReach - bn3Result;

    var inteReach = mediaABCReach - (tmp1 + tmp2 + tmp3) + tmp4;

    maxReachMediaInfo.grps = inteGRP;
    // 판별식 추가해야함.
    if(inteReach > maxReach && inteReach < mediaABCReach){
      maxReachMediaInfo.reach1 = inteReach;
    }else if(inteReach <= maxReach){
      maxReachMediaInfo.reach1 = maxReach;
    }else if(inteReach >= mediaABCReach){
      maxReachMediaInfo.reach1 = mediaABCReach;
    }
    mediaTemplate.resultMedia = maxReachMediaInfo;
  },
  BN3_calc(mediaA, mediaB, mediaC, int_cffcnt_CD, inte_cffcnt){
    // var mediaABCReach =  parseFloat(mediaA.reach1) + parseFloat(mediaB.reach1) + parseFloat(mediaC.reach1);
    var cffcnt = inte_cffcnt[int_cffcnt_CD];
    var z1 = Math.log((mediaA.reach1/100)/(cffcnt.ca-mediaB.reach1/100))*cffcnt.ba
    var z2 = Math.log((mediaB.reach1/100)/(cffcnt.cb-mediaB.reach1/100))*cffcnt.bb
    var z3 = Math.log((mediaC.reach1/100)/(cffcnt.cc-mediaC.reach1/100))*cffcnt.bc
    var z4 = cffcnt.cint / (1+Math.exp((cffcnt.a + (z1 + z2 + z3))*-1));
    // var inteReach = mediaABCReach - z4;
    return z4*100; // 중복노출값
  },
  A3_Logic: function(mediaTemplate, channel1, channel2, channel3, int_cffcnt_CD, inte_cffcnt){
    // console.log('A3_Logic 시작');
    // var maxReach = channel1.reach1>=channel2.reach1 ? channel1.reach1 : channel2.reach1;
    var maxReach = Math.max(channel1.reach1, channel2.reach1, channel3.reach1);
    // console.log('max : ' + maxReach);
    var maxReachMediaInfo = $.extend(true, {}, channel1)
    var inteGRP  = parseFloat(channel1.grps) + parseFloat(channel2.grps) + parseFloat(channel3.grps);
    var inteReach = parseFloat(channel1.reach1) + parseFloat(channel2.reach1)  + parseFloat(channel3.reach1);

    var channel1Reach = parseFloat(channel1.reach1);
    var channel2Reach  = parseFloat(channel2.reach1);
    var channel3Reach  = parseFloat(channel3.reach1);

    var a = inte_cffcnt[int_cffcnt_CD].a;
    var channel1B = inte_cffcnt[int_cffcnt_CD].b2_1;
    var channel2B = inte_cffcnt[int_cffcnt_CD].b2_2;
    var channel3B = inte_cffcnt[int_cffcnt_CD].b2_3;
    var channel1B_channel2B = inte_cffcnt[int_cffcnt_CD].b4;
    var channel1B_channel3B = inte_cffcnt[int_cffcnt_CD].b5;
    var channel2B_channel3B = inte_cffcnt[int_cffcnt_CD].b6;
    var channel1B_channel2B_channel3B = inte_cffcnt[int_cffcnt_CD].b7;

    var z1 = (channel1Reach/100)*channel1B + (channel2Reach/100)*channel2B + (channel3Reach/100)*channel3B ;
    var z2 = (channel1Reach/100)*(channel2Reach/100)*channel1B_channel2B
    + (channel1Reach/100)*(channel3Reach/100)*channel1B_channel3B;
    var z3 = (channel2Reach/100)*(channel3Reach/100)*channel2B_channel3B;
    var z4 = (channel1Reach/100)*(channel2Reach/100)*(channel3Reach/100)*channel1B_channel2B_channel3B;

    var reach =( a + z1 + z2 + z3 + z4 ) * 100;
    // 계산후 검증 과;
    if(reach <maxReach){
      reach = maxReach;
    }else if(reach>100){
      reach = 100
    }else if(reach > inteReach){
      reach = inteReach;
    }
    maxReachMediaInfo.reach1 = reach;
    maxReachMediaInfo.grps = inteGRP;
    mediaTemplate.resultMedia = maxReachMediaInfo;
  },
}



// WEBPACK FOOTER //
// ./src/views/common/ReachLogic.js